import { devApi } from './dev.api';
import { productionApi } from './production.api';
import { stagingApi } from './staging.api';

// Dev
const devConfig = {
  api: devApi,
  host: 'contact.ed.gtc.goto.com',
};

// Staging
const stagingConfig = {
  api: stagingApi,
  host: 'contact.stage.gtc.goto.com',
};

// Prod
const productionConfig = {
  api: productionApi,
  host: 'contact.goto.com',
};

export enum Environments {
  DEVELOPMENT = 'dev',
  STAGING = 'staging',
  PRODUCTION = 'prod',
  LOCAL = 'local',
}

const configurations = {
  [Environments.DEVELOPMENT]: devConfig,
  [Environments.STAGING]: stagingConfig,
  [Environments.PRODUCTION]: productionConfig,
  [Environments.LOCAL]: {
    ...devConfig,
    appKey: '022a52bb-ff1c-442e-9720-3a17ccd56d95', // dev complete (Yuri - Webchat)
    // appKey: 'db803bab-2cd8-4b6c-9b72-e5c5609923ad', // dev complete (Yuri - Webchat - 2)
  },
};

export const getEnvString = () =>
  process?.env?.REACT_APP_ENV ||
  Object.keys(configurations).find(
    environment => window.location.hostname === configurations[environment].host
  ) ||
  Environments.DEVELOPMENT;

export const environment = configurations[getEnvString()];
